import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "align-center",
  "use": "align-center-usage",
  "viewBox": "0 0 192 192",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 192 192\" id=\"align-center\">\n<path d=\"M152,152H40c-4.4,0-8-3.6-8-8s3.6-8,8-8h112c4.4,0,8,3.6,8,8S156.4,152,152,152z\" />\n<path d=\"M136,120H56c-4.4,0-8-3.6-8-8s3.6-8,8-8h80c4.4,0,8,3.6,8,8S140.4,120,136,120z\" />\n<path d=\"M152,88H40c-4.4,0-8-3.6-8-8s3.6-8,8-8h112c4.4,0,8,3.6,8,8S156.4,88,152,88z\" />\n<path d=\"M136,56H56c-4.4,0-8-3.6-8-8s3.6-8,8-8h80c4.4,0,8,3.6,8,8S140.4,56,136,56z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/align-center.svg
// module id = 1835
// module chunks = 0